<template>
    <div class="is-clearfix">
        <div class="columns">
            <div class="column is-12 is-6-desktop" v-if="headline">
                <h3 v-if="headline" class="is-size-5 is-uppercase title is-pulled-left">{{headline}}</h3>
            </div>
            <div class="column is-12" :class="headline ? 'is-6-desktop has-text-right': ''">
                <button v-if="!formShown"
                    :class="(small === 'true') ? 'is-narrow is-small' : ''"
                    class="button action-button is-outline is-primary"
                    @click="formShown = !formShown"
                    title="Partner hinzufügen"
                    @hover="showAction('add')">
                    <span class="has-margin-right-1">{{ (label !== undefined && label !== '') ? label : 'Partner erstellen'}}</span> <i v-if="!formShown" class="fa fa-plus"></i>
                </button>
                    <button v-if="formShown" :class="(small === 'true') ? 'is-narrow is-small' : ''" class="button action-button is-primary" @click="formShown = !formShown" title="Partner hinzufügen">
                    <span class="has-margin-right-1">Formular verbergen</span><i class="fa fa-minus"></i>
                </button>
            </div>
        </div>

        <div class="form ck-new-partner" v-if="formShown">
            <div>
                <transition name="bounce">
                    <ck-flash :message="formErrors.message"  :type="'is-warning'" v-if="formErrors.message !== ''"></ck-flash>
                    <ck-flash message="Partner erstellt!" :type="'is-success'" v-if="createSuccess">
                    </ck-flash>
                </transition>
            </div>
            <div class="field">
                <div class="control">
                    <div class="select">
                    <label class="label" for="partner_type"></label>
                    <select name="partner_type" v-model="selectedType" id="partner_type" @change="selectType">
                        <option v-for="type in types" :value="type.name" :key="type.name">{{type.value}}</option>
                    </select>
                    </div>
                </div>
            </div>
            <div class="field-group" v-if="selectedType === 'club'">
                <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Allgemein</h3>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="name">Vereinsname</label>
                                <input class="input" type="text" id="name" v-model="club.name">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="phonenumber">Telefon</label>
                                <input class="input" type="text" id="phonenumber" v-model="club.phonenumber">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-4-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="email">Email</label>
                                <input class="input" type="text" id="email" v-model="club.email">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-4-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.homepage">Vereinshomepage</label>
                                <input class="input" type="text" id="club.homepage" v-model="club.homepage">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-4-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.transfermarkt_link">Transfermarkt Link</label>
                                <input class="input" type="text" id="club.transfermarkt_link" v-model="club.transfermarkt_link">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="description">Notizen</label>
                                <textarea class="textarea" type="text" id="description" v-model="club.description"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Adresse</h3>
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="field">
                            <div class="control ck-search-select">
                                <label class="label" for="country">Land</label>
                                <model-select :options="options"
                                                v-model="club.country"
                                                placeholder="Land auswählen"
                                                >
                                    </model-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="address">Straße/Hausnummer</label>
                                <input class="input" type="text" id="address" v-model="club.address">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="postalcode">Postleitzahl</label>
                                <input class="input" type="text" id="postalcode" v-model="club.postalcode">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="city">Stadt</label>
                                <input class="input" type="text" id="city" v-model="club.city">
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Funktionäre</h3>

                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Präsident">Präsident</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Präsident"
                                    v-model="club.positions.Präsident"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Vize_Präsident">Vize Präsident</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Vize_Präsident"
                                    v-model="club.positions.Vize_Präsident"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Geschäftsführer">Geschäftsführer</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Geschäftsführer"
                                    v-model="club.positions.Geschäftsführer"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Obmann">Obmann</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Obmann"
                                    v-model="club.positions.Obmann"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Sportlicher_Leiter">Sportlicher Leiter</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Sportlicher_Leiter"
                                    v-model="club.positions.Sportlicher_Leiter"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Sportlicher_Leiter_Nachwuchs">Sportlicher Leiter Nachwuchs</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Sportlicher_Leiter_Nachwuchs"
                                    v-model="club.positions.Sportlicher_Leiter_Nachwuchs"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Sektionsleiter">Sektionsleiter</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Sektionsleiter"
                                    v-model="club.positions.Sektionsleiter"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Akademieleiter">Akademieleiter</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Akademieleiter"
                                    v-model="club.positions.Akademieleiter"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Nachwuchsleiter">Nachwuchsleiter</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Nachwuchsleiter"
                                    v-model="club.positions.Nachwuchsleiter"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Trainer_Kampfmannschaft">Trainer Kampfmannschaft</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Trainer_Kampfmannschaft"
                                    v-model="club.positions.Trainer_Kampfmannschaft"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.CoTrainer_Kampfmannschaft">Co-Trainer Kampfmannschaft</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.CoTrainer_Kampfmannschaft"
                                    v-model="club.positions.CoTrainer_Kampfmannschaft"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Trainer_Amateure">Trainer Amateure</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Trainer_Amateure"
                                    v-model="club.positions.Trainer_Amateure"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.CoTrainer_Amateure">Co-Trainer Amateure</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.CoTrainer_Amateure"
                                    v-model="club.positions.CoTrainer_Amateure"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Trainer_U18">Trainer U18</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Trainer_U18"
                                    v-model="club.positions.Trainer_U18"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.CoTrainer_U18">Co-Trainer U18</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.CoTrainer_U18"
                                    v-model="club.positions.CoTrainer_U18"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Trainer_U16">Trainer U16</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Trainer_U16"
                                    v-model="club.positions.Trainer_U16"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.CoTrainer_U16">Co-Trainer U16</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.CoTrainer_U16"
                                    v-model="club.positions.CoTrainer_U16"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Trainer_U15">Trainer U15</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Trainer_U15"
                                    v-model="club.positions.Trainer_U15"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.CoTrainer_U15">Co-Trainer U15</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.CoTrainer_U15"
                                    v-model="club.positions.CoTrainer_U15"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Trainer_U14">Trainer U14</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Trainer_U14"
                                    v-model="club.positions.Trainer_U14"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.CoTrainer_U14">Co-Trainer U14</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.CoTrainer_U14"
                                    v-model="club.positions.CoTrainer_U14"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Masseur">Masseur</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Masseur"
                                    v-model="club.positions.Masseur"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Sportwissenschaftler">Sportwissenschaftler</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Sportwissenschaftler"
                                    v-model="club.positions.Sportwissenschaftler"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Sportpsychologe">Sportpsychologe</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Sportpsychologe"
                                    v-model="club.positions.Sportpsychologe"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Athletiktrainer">Athletiktrainer</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Athletiktrainer"
                                    v-model="club.positions.Athletiktrainer"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Individualtrainer">Individualtrainer</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Individualtrainer"
                                    v-model="club.positions.Individualtrainer"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Tormanntrainer">Tormanntrainer</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Tormanntrainer"
                                    v-model="club.positions.Tormanntrainer"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Teamarzt">Teamarzt</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Teamarzt"
                                    v-model="club.positions.Teamarzt"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="club.positions.Videoanalyst">Videoanalyst</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="club.positions.Videoanalyst"
                                    v-model="club.positions.Videoanalyst"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field-group" v-if="selectedType === 'person'">
                <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Allgemein</h3>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control is-required is-fullwidth">
                                <div class="ck-search">
                                    <label for="positions" class="label">Titel</label>
                                    <model-select :options="titleList"
                                        v-model="person.title"
                                        placeholder="Club/Company Auswählen"
                                        @input="onPositionSelect"
                                        >
                                    </model-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop"></div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control is-required">
                                <label for="firstname" class="label">Vorname</label>
                                <input type="text" class="input" :class="(formErrors.errors.firstname) ? 'is-warning' : ''" name="firstname" id="firstname" v-model="person.firstname">
                                <p class="help is-danger" v-if="formErrors.errors.firstname">
                                    Muss ausgefüllt werden.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control is-required">
                                <label for="lastname" class="label">Nachname</label>
                                <input type="text" class="input" :class="(formErrors.errors.lastname) ? 'is-warning' : ''" name="lastname" id="lastname" v-model="person.lastname">
                                <p class="help is-danger" v-if="formErrors.errors.lastname">
                                    Muss ausgefüllt werden.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label for="email" class="label">Email</label>
                                <input type="email" class="input" :class="(formErrors.errors.email) ? 'is-danger' : ''" name="email" id="email" v-model="person.email">
                                <p class="help is-danger" v-if="formErrors.errors.email">
                                    Muss ausgefüllt werden wenn CK Sport Account angelegt werden soll.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                       <div class="field">
                            <div class="control">
                                <label for="person.homepage" class="label">Homepage</label>
                                <input type="text" class="input" name="person.homepage" id="person.homepage" v-model="person.homepage">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                         <div class="field">
                            <div class="control">
                                <label for="phonenumber" class="label">Telefonnummer</label>
                                <input type="text" class="input" name="phonenumber" id="phonenumber" v-model="person.phonenumber">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label for="person.workphonenumber" class="label">Telefon Arbeit</label>
                                <input type="text" class="input" name="person.workphonenumber" id="person.workphonenumber" v-model="person.workphonenumber">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label for="person.mobilephonenumber" class="label">Telefon Mobil</label>
                                <input
                                    type="text"
                                    class="input"
                                    name="person.mobilephonenumber"
                                    id="person.mobilephonenumber"
                                    v-model="person.mobilephonenumber">
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label for="birthday" class="label">Geburtsdatum</label>
                                <input v-pikaday class="input" name="birthday" id="birthday" v-model="person.birthday">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label for="positions" class="label">Beruf / Position</label>
                                <model-select :options="positionList"
                                        v-model="person.positions"
                                        placeholder="Club/Company Auswählen"
                                        @input="onPositionSelect"
                                        >
                                </model-select>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12 is-6-desktop">
                        <div class="field">
                            <div class="control">
                                <label for="club_company" class="label">Club / Unternehmen</label>
                                <model-select :options="partnerlist"
                                        v-model="person.club_company"
                                        placeholder="Club/Company Auswählen"
                                        >
                                </model-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <input type="text"
                            class="input"
                            name="positions"
                            id="positions"
                            v-if="showPositionFreeText === true"
                            v-model="person.positions"
                            placeholder="Andere Position eingeben...">
                    </div>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12 has-margin-top-1 has-margin-bottom-1">
                        <div class="field">
                            <div class="control">
                                <label for="has_account" class="checkbox label">
                                <input type="checkbox" name="has_account" id="has_account" v-model="person.create_account">
                                <span class="has-padding-left-0-5">CK Sport Account anlegen?</span></label>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Familie</h3>
                <div class="field">
                    <div class="control">
                        <label for="marital_status" class="label">Familienstand</label>
                        <input name="marital_status" type="text" class="input" v-model="person.marital_status">
                    </div>
                </div>
                <h4 class="is-size-6 has-text-weight-bold has-margin-top-1 has-margin-bottom-1">Verwandte</h4>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input has-margin-right-1 input-padded" aria-label="Name" type="text" v-model="relativeinput.name" placeholder="Name">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input input-padded " aria-label="Geburtstag" v-pikaday v-model="relativeinput.birthday" placeholder="Geburtstag">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <model-select :options="relativeTypeList"
                                        v-model="relativeinput.type"
                                        placeholder="Art der Verwandschaft"
                                        >
                                </model-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <textarea name="relative_annotation" class="textarea" id="" cols="30" rows="4" v-model="relativeinput.description" placeholder="Notizen/Beschreibung">
                                </textarea>
                            </div>
                        </div>
                        <div class="control">
                            <button class="button is-primary" @click.prevent="addRelative">
                            Erstellen
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="(person.relatives.length > 0)">
                    <h4 class="has-margin-bottom-1 has-margin-top-1 has-text-weight-bold">Werden hinzugefügt:</h4>
                    <table class="table is-fullwidth">
                        <thead>
                            <th>Art</th>
                            <th>Name</th>
                            <th>Geburtstag</th>
                        </thead>
                        <tbody>
                            <tr v-for="relative in person.relatives" v-bind:key="relative.id">
                                <td>{{relative.type}}</td>
                                <td>{{relative.name}} </td>
                                <td>{{relative.birthday}} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Adresse</h3>
                <div class="field">
                    <div class="control ck-search-select">
                        <label class="label" for="country">Land</label>
                        <model-select :options="options"
                                        v-model="person.country"
                                        placeholder="Land auswählen"
                                        >
                            </model-select>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label for="adress" class="label">Straße und Hausnummer</label>
                                <input type="text" class="input" name="adress" id="adress" v-model="person.address">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label for="postalcode" class="label">Postleitzahl</label>
                                <input type="text" class="input" name="postalcode" id="postalcode" v-model="person.postalcode">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label for="city" class="label">Stadt</label>
                                <input type="text" class="input" name="city" id="city" v-model="person.city">
                            </div>
                        </div>
                    </div>

                </div>
                 <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Sonstiges</h3>
                <div class="field">
                    <div class="control">
                        <label for="hobbies" class="label">Hobbies</label>
                        <textarea type="text" class="textarea" name="hobbies" id="hobbies" v-model="person.hobbies"></textarea>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label for="description" class="label">Beschreibung/Notizen</label>
                                <textarea type="text" class="textarea" name="description" id="description" v-model="person.description"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="field-group" v-if="selectedType === 'company'">
                <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Allgemein</h3>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="name">Firmenname</label>
                                <input class="input" type="text" id="name" v-model="company.name">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label class="label" for="phonenumber">Telefon</label>
                                <input class="input" type="text" id="phonenumber" v-model="company.phonenumber">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="email">Email</label>
                                <input class="input" type="text" id="email" v-model="company.email">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.homepage">Firmenhomepage</label>
                                <input class="input" type="text" id="company.homepage" v-model="company.homepage">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <label class="label" for="description">Beschreibung</label>
                        <textarea class="textarea" type="text" id="description" v-model="company.description"></textarea>
                    </div>
                </div>
                <h3 class="is-size-5 has-margin-top-2 has-margin-bottom-1">Adresse</h3>
                <div class="field">
                    <div class="control ck-search-select">
                        <label class="label" for="country">Land</label>
                        <model-select :options="options"
                                        v-model="company.country"
                                        placeholder="Land auswählen"
                                        >
                        </model-select>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="address">Straße / Hausnummer</label>
                                <input class="input" type="text" id="address" v-model="company.address">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="postalcode">Postleitzahl</label>
                                <input class="input" type="text" id="postalcode" v-model="company.postalcode">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label class="label" for="city">Stadt</label>
                                <input class="input" type="text" id="city" v-model="company.city">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.positions.Präsident">Geschäftsführer</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="company.positions.Geschäftsführer"
                                    v-model="company.positions.Geschäftsführer"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.positions.">Inhaber/in</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="company.positions.Inhaber"
                                    v-model="company.positions.Inhaber"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.positions.Geschäftsführer">Eigentümer</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="company.positions.Eigentümer"
                                    v-model="company.positions.Eigentümer"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.positions.Präsident">Abteilungsleiter/in</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="company.positions.Abteilungsleiter"
                                    v-model="company.positions.Abteilungsleiter"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.positions.">Gebietsleiter/in</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="company.positions.Gebietsleiter"
                                    v-model="company.positions.Gebietsleiter"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.positions.Geschäftsführer">Verkäufer/in</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="company.positions.Verkäufer"
                                    v-model="company.positions.Verkäufer"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.positions.Präsident">Sekretär/in</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="company.positions.Sekretär"
                                    v-model="company.positions.Sekretär"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <label class="label" for="company.positions.Buchhalter">Buchhalter/in</label>
                                <input
                                    class="input"
                                    type="text"
                                    id="company.positions.Buchhalter"
                                    v-model="company.positions.Buchhalter"
                                    placeholder="Nachname Vorname">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field-group has-margin-top-1">
                <div class="field">
                    <div class="control">
                        <button class="button is-primary" :class="(loading) ? 'is-loading' : ''" @click="sendForm" ><span v-if="createSuccess"><i class="fa fa-check"></i> Erstellt</span> <span v-if="!createSuccess">Erstellen</span></button>
                    </div>
                </div>
            </div>
        </div>
        <transition name="bounce">
        <ck-flash :message="flash.message"  :type="flash.type" v-if="createSuccess"></ck-flash>
        </transition>
    </div>

</template>


<script>
import { ModelSelect } from 'vue-search-select';
import V_Pikaday from '../directives/pikaday';

export default {
    props: ['default', 'label', 'small', 'headline'],
    directives: {
         'pikaday': V_Pikaday
    },
    data() {
        return {
            types: [
                {name: 'person', value: 'Person'},
                {name: 'club', value: 'Verein'},
                {name: 'company', value: 'Unternehmen'},
            ],
            formShown: false,
            selectedType: null,
            showPositionFreeText: false,
            fields: {},
            selectedCountries: {
                value: '',
                text: ''
            },
            options: [
                {text: 'Afghanistan', value: 'Afghanistan'},
                {text: 'Ägypten', value: 'Ägypten'},
                {text: 'Åland', value: 'Åland'},
                {text: 'Albanien', value: 'Albanien'},
                {text: 'Algerien', value: 'Algerien'},
                {text: 'Amerikanisch-Samoa', value: 'Amerikanisch-Samoa'},
                {text: 'Andorra', value: 'Andorra'},
                {text: 'Angola', value: 'Angola'},
                {text: 'Anguilla', value: 'Anguilla'},
                {text: 'Antarktis', value: 'Antarktis'},
                {text: 'Antigua und Barbuda', value: 'Antigua und Barbuda'},
                {text: 'Äquatorial Guinea', value: 'Äquatorial Guinea'},
                {text: 'Argentinien', value: 'Argentinien'},
                {text: 'Armenien', value: 'Armenien'},
                {text: 'Aruba', value: 'Aruba'},
                {text: 'Aserbaidschan', value: 'Aserbaidschan'},
                {text: 'Äthiopien', value: 'Äthiopien'},
                {text: 'Australien', value: 'Australien'},
                {text: 'Bahamas', value: 'Bahamas'},
                {text: 'Bahrain', value: 'Bahrain'},
                {text: 'Bangladesch', value: 'Bangladesch'},
                {text: 'Barbados', value: 'Barbados'},
                {text: 'Belarus', value: 'Belarus'},
                {text: 'Belgien', value: 'Belgien'},
                {text: 'Belize', value: 'Belize'},
                {text: 'Benin', value: 'Benin'},
                {text: 'Bermuda', value: 'Bermuda'},
                {text: 'Bhutan', value: 'Bhutan'},
                {text: 'Bolivien', value: 'Bolivien'},
                {text: 'Bonaire, Sint Eustatius und Saba', value: 'Bonaire, Sint Eustatius und Saba'},
                {text: 'Bosnien und Herzegowina', value: 'Bosnien und Herzegowina'},
                {text: 'Botsuana', value: 'Botsuana'},
                {text: 'Bouvetinsel', value: 'Bouvetinsel'},
                {text: 'Brasilien', value: 'Brasilien'},
                {text: 'Britisches Territorium im Indischen Ozean', value: 'Britisches Territorium im Indischen Ozean'},
                {text: 'Brunei Darussalam', value: 'Brunei Darussalam'},
                {text: 'Bulgarien', value: 'Bulgarien'},
                {text: 'Burkina Faso', value: 'Burkina Faso'},
                {text: 'Burundi', value: 'Burundi'},
                {text: 'Chile', value: 'Chile'},
                {text: 'China', value: 'China'},
                {text: 'Cook-Inseln', value: 'Cook-Inseln'},
                {text: 'Costa Rica', value: 'Costa Rica'},
                {text: 'Elfenbeinküste', value: 'Elfenbeinküste'},
                {text: 'Curaçao', value: 'Curaçao'},
                {text: 'Dänemark', value: 'Dänemark'},
                {text: 'Deutschland', value: 'Deutschland'},
                {text: 'Dominica', value: 'Dominica'},
                {text: 'Dominikanische Republik', value: 'Dominikanische Republik'},
                {text: 'Dschibuti', value: 'Dschibuti'},
                {text: 'Ecuador', value: 'Ecuador'},
                {text: 'El Salvador', value: 'El Salvador'},
                {text: 'Eritrea', value: 'Eritrea'},
                {text: 'Estland', value: 'Estland'},
                {text: 'Eswatini', value: 'Eswatini'},
                {text: 'Falklandinseln (Malvinen)', value: 'Falklandinseln (Malvinen)'},
                {text: 'Färöer-Inseln', value: 'Färöer-Inseln'},
                {text: 'Fidschi', value: 'Fidschi'},
                {text: 'Finnland', value: 'Finnland'},
                {text: 'Frankreich', value: 'Frankreich'},
                {text: 'Französische Südgebiete', value: 'Französische Südgebiete'},
                {text: 'Französisch Guayana', value: 'Französisch Guayana'},
                {text: 'Französisch Polynesien', value: 'Französisch Polynesien'},
                {text: 'Gabun', value: 'Gabun'},
                {text: 'Gambia', value: 'Gambia'},
                {text: 'Georgien', value: 'Georgien'},
                {text: 'Ghana', value: 'Ghana'},
                {text: 'Gibraltar', value: 'Gibraltar'},
                {text: 'Grenada', value: 'Grenada'},
                {text: 'Griechenland', value: 'Griechenland'},
                {text: 'Grönland', value: 'Grönland'},
                {text: 'Guadeloupe', value: 'Guadeloupe'},
                {text: 'Guam', value: 'Guam'},
                {text: 'Guatemala', value: 'Guatemala'},
                {text: 'Guernsey', value: 'Guernsey'},
                {text: 'Guinea', value: 'Guinea'},
                {text: 'Guinea-Bissau', value: 'Guinea-Bissau'},
                {text: 'Guyana', value: 'Guyana'},
                {text: 'Haiti', value: 'Haiti'},
                {text: 'Heard und McDonald-Inseln', value: 'Heard und McDonald-Inseln'},
                {text: 'Honduras', value: 'Honduras'},
                {text: 'Hongkong', value: 'Hongkong'},
                {text: 'Indien', value: 'Indien'},
                {text: 'Indonesien', value: 'Indonesien'},
                {text: 'Irak', value: 'Irak'},
                {text: 'Iran, Islamische Republik', value: 'Iran, Islamische Republik'},
                {text: 'Irland', value: 'Irland'},
                {text: 'Island', value: 'Island'},
                {text: 'Israel', value: 'Israel'},
                {text: 'Italien', value: 'Italien'},
                {text: 'Jamaika', value: 'Jamaika'},
                {text: 'Japan', value: 'Japan'},
                {text: 'Jemen', value: 'Jemen'},
                {text: 'Jersey', value: 'Jersey'},
                {text: 'Jordanien', value: 'Jordanien'},
                {text: 'Jungfern-Inseln Britisch', value: 'Jungfern-Inseln Britisch'},
                {text: 'Jungfern-Inseln USA', value: 'Jungfern-Inseln USA'},
                {text: 'Kaimaninseln', value: 'Kaimaninseln'},
                {text: 'Kambodscha', value: 'Kambodscha'},
                {text: 'Kamerun', value: 'Kamerun'},
                {text: 'Kanada', value: 'Kanada'},
                {text: 'Kap Verde', value: 'Kap Verde'},
                {text: 'Kasachstan', value: 'Kasachstan'},
                {text: 'Katar', value: 'Katar'},
                {text: 'Kenia', value: 'Kenia'},
                {text: 'Kirgisistan', value: 'Kirgisistan'},
                {text: 'Kiribati', value: 'Kiribati'},
                {text: 'Kokosinseln (Keeling)', value: 'Kokosinseln (Keeling)'},
                {text: 'Kolumbien', value: 'Kolumbien'},
                {text: 'Komoren', value: 'Komoren'},
                {text: 'Kongo', value: 'Kongo'},
                {text: 'Kongo, Demokratische Republik', value: 'Kongo, Demokratische Republik'},
                {text: 'Korea, Demokratische Volksrepublik', value: 'Korea, Demokratische Volksrepublik'},
                {text: 'Korea, Republik', value: 'Korea, Republik'},
                {text: 'Kroatien', value: 'Kroatien'},
                {text: 'Kuba', value: 'Kuba'},
                {text: 'Kuwait', value: 'Kuwait'},
                {text: 'Laos, Demokratische Volksrepublik', value: 'Laos, Demokratische Volksrepublik'},
                {text: 'Lesotho', value: 'Lesotho'},
                {text: 'Lettland', value: 'Lettland'},
                {text: 'Libanon', value: 'Libanon'},
                {text: 'Liberien', value: 'Liberien'},
                {text: 'Libyen', value: 'Libyen'},
                {text: 'Liechtenstein', value: 'Liechtenstein'},
                {text: 'Litauen', value: 'Litauen'},
                {text: 'Luxemburg', value: 'Luxemburg'},
                {text: 'Macao', value: 'Macao'},
                {text: 'Madagaskar', value: 'Madagaskar'},
                {text: 'Malawi', value: 'Malawi'},
                {text: 'Malaysia', value: 'Malaysia'},
                {text: 'Malediven', value: 'Malediven'},
                {text: 'Mali', value: 'Mali'},
                {text: 'Malta', value: 'Malta'},
                {text: 'Man Insel', value: 'Man Insel'},
                {text: 'Marokko', value: 'Marokko'},
                {text: 'Marshall-Inseln', value: 'Marshall-Inseln'},
                {text: 'Martinique', value: 'Martinique'},
                {text: 'Mauretanien', value: 'Mauretanien'},
                {text: 'Mauritius', value: 'Mauritius'},
                {text: 'Mayotte', value: 'Mayotte'},
                {text: 'Mexiko', value: 'Mexiko'},
                {text: 'Mikronesien', value: 'Mikronesien'},
                {text: 'Moldau, Republik', value: 'Moldau, Republik'},
                {text: 'Monaco', value: 'Monaco'},
                {text: 'Mongolei', value: 'Mongolei'},
                {text: 'Montenegro', value: 'Montenegro'},
                {text: 'Montserrat', value: 'Montserrat'},
                {text: 'Mosambik', value: 'Mosambik'},
                {text: 'Myanmar', value: 'Myanmar'},
                {text: 'Namibia', value: 'Namibia'},
                {text: 'Nauru', value: 'Nauru'},
                {text: 'Nepal', value: 'Nepal'},
                {text: 'Neukaledonien', value: 'Neukaledonien'},
                {text: 'Neuseeland', value: 'Neuseeland'},
                {text: 'Nicaragua', value: 'Nicaragua'},
                {text: 'Niederlande', value: 'Niederlande'},
                {text: 'Niederländische Antillen', value: 'Niederländische Antillen'},
                {text: 'Niger', value: 'Niger'},
                {text: 'Nigeria', value: 'Nigeria'},
                {text: 'Niue', value: 'Niue'},
                {text: 'Nördliche Marianen', value: 'Nördliche Marianen'},
                {text: 'Nordmazedonien', value: 'Nordmazedonien'},
                {text: 'Norfolkinsel', value: 'Norfolkinsel'},
                {text: 'Norwegen', value: 'Norwegen'},
                {text: 'Oman', value: 'Oman'},
                {text: 'Österreich', value: 'Österreich'},
                {text: 'Pakistan', value: 'Pakistan'},
                {text: 'Palästina, Staat', value: 'Palästina, Staat'},
                {text: 'Palau', value: 'Palau'},
                {text: 'Panama', value: 'Panama'},
                {text: 'Papua Neuguinea', value: 'Papua Neuguinea'},
                {text: 'Paraguay', value: 'Paraguay'},
                {text: 'Peru', value: 'Peru'},
                {text: 'Philippinen', value: 'Philippinen'},
                {text: 'Pitcairn Inseln', value: 'Pitcairn Inseln'},
                {text: 'Polen', value: 'Polen'},
                {text: 'Portugal', value: 'Portugal'},
                {text: 'Puerto Rico', value: 'Puerto Rico'},
                {text: 'Réunion', value: 'Réunion'},
                {text: 'Ruanda', value: 'Ruanda'},
                {text: 'Rumänien', value: 'Rumänien'},
                {text: 'Russische Föderation', value: 'Russische Föderation'},
                {text: 'Saint Barthélemy', value: 'Saint Barthélemy'},
                {text: 'Saint Martin (franz. Teil)', value: 'Saint Martin (franz. Teil)'},
                {text: 'Salomonen', value: 'Salomonen'},
                {text: 'Sambia', value: 'Sambia'},
                {text: 'Samoa', value: 'Samoa'},
                {text: 'San Marino', value: 'San Marino'},
                {text: 'São Tomé und Príncipe', value: 'São Tomé und Príncipe'},
                {text: 'Saudi-Arabien', value: 'Saudi-Arabien'},
                {text: 'Schweden', value: 'Schweden'},
                {text: 'Schweiz', value: 'Schweiz'},
                {text: 'Senegal', value: 'Senegal'},
                {text: 'Serbien', value: 'Serbien'},
                {text: 'Serbien und Montenegro', value: 'Serbien und Montenegro'},
                {text: 'Seychellen', value: 'Seychellen'},
                {text: 'Sierra Leone', value: 'Sierra Leone'},
                {text: 'Simbabwe', value: 'Simbabwe'},
                {text: 'Singapur', value: 'Singapur'},
                {text: 'Sint Maarten (niederländischer Teil)', value: 'Sint Maarten (niederländischer Teil)'},
                {text: 'Slowakei', value: 'Slowakei'},
                {text: 'Slowenien', value: 'Slowenien'},
                {text: 'Somalia', value: 'Somalia'},
                {text: 'Spanien', value: 'Spanien'},
                {text: 'Sri Lanka', value: 'Sri Lanka'},
                {text: 'St. Helena, Ascension und Tristan da Cunha', value: 'St. Helena, Ascension und Tristan da Cunha'},
                {text: 'St. Kitts und Nevis', value: 'St. Kitts und Nevis'},
                {text: 'St. Lucia', value: 'St. Lucia'},
                {text: 'St. Pierre und Miquelon', value: 'St. Pierre und Miquelon'},
                {text: 'St. Vincent und die Grenadinen', value: 'St. Vincent und die Grenadinen'},
                {text: 'Südafrika', value: 'Südafrika'},
                {text: 'Sudan', value: 'Sudan'},
                {text: 'Sudan', value: 'Sudan'},
                {text: 'Südgeorgien und die Südlichen-Sandwich-Inseln', value: 'Südgeorgien und die Südlichen-Sandwich-Inseln'},
                {text: 'Südsudan', value: 'Südsudan'},
                {text: 'Suriname', value: 'Suriname'},
                {text: 'Svalbard und Jan Mayen', value: 'Svalbard und Jan Mayen'},
                {text: 'Syrien, Arabische Republik', value: 'Syrien, Arabische Republik'},
                {text: 'Tadschikistan', value: 'Tadschikistan'},
                {text: 'Taiwan', value: 'Taiwan'},
                {text: 'Tansania, Vereinigte Republik', value: 'Tansania, Vereinigte Republik'},
                {text: 'Thailand', value: 'Thailand'},
                {text: 'Timor-Leste', value: 'Timor-Leste'},
                {text: 'Togo', value: 'Togo'},
                {text: 'Tokelau', value: 'Tokelau'},
                {text: 'Tonga', value: 'Tonga'},
                {text: 'Trinidad und Tobago', value: 'Trinidad und Tobago'},
                {text: 'Tschad', value: 'Tschad'},
                {text: 'Tschechien', value: 'Tschechien'},
                {text: 'Tunesien', value: 'Tunesien'},
                {text: 'Türkei', value: 'Türkei'},
                {text: 'Turkmenistan', value: 'Turkmenistan'},
                {text: 'Turks- und Caicosinseln', value: 'Turks- und Caicosinseln'},
                {text: 'Tuvalu', value: 'Tuvalu'},
                {text: 'Uganda', value: 'Uganda'},
                {text: 'Ukraine', value: 'Ukraine'},
                {text: 'Ungarn', value: 'Ungarn'},
                {text: 'Uruguay', value: 'Uruguay'},
                {text: 'Usbekistan', value: 'Usbekistan'},
                {text: 'Vanuatu', value: 'Vanuatu'},
                {text: 'Vatikan', value: 'Vatikan'},
                {text: 'Venezuela, Bolivarische Republik', value: 'Venezuela, Bolivarische Republik'},
                {text: 'Vereinigte Arabische Emirate', value: 'Vereinigte Arabische Emirate'},
                {text: 'Vereinigtes Königreich Großbritannien und Nordirland', value: 'Vereinigtes Königreich Großbritannien und Nordirland'},
                {text: 'Vereinigte Staaten Minor Outlying Islands', value: 'Vereinigte Staaten Minor Outlying Islands'},
                {text: 'Vereinigte Staaten von Amerika', value: 'Vereinigte Staaten von Amerika'},
                {text: 'Vietnam', value: 'Vietnam'},
                {text: 'Wallis und Futuna', value: 'Wallis und Futuna'},
                {text: 'Weihnachtsinsel', value: 'Weihnachtsinsel'},
                {text: 'Westsahara', value: 'Westsahara'},
                {text: 'Zentralafrikanische Republik', value: 'Zentralafrikanische Republik'},
                {text: 'Zypern', value: 'Zypern'},
            ],
            positionList: [
                {text: 'Präsident', value: 'Präsident'},
                {text: 'Vize Präsident', value: 'Vize_Präsident'},
                {text: 'Geschäftsführer', value: 'Geschäftsführer'},
                {text: 'Obmann', value: 'Obmann'},
                {text: 'Sportlicher Leiter', value: 'Sportlicher_Leiter'},
                {text: 'Sportlicher Leiter Nachwuchs', value: 'Sportlicher_Leiter_Nachwuchs'},
                {text: 'Sektionsleiter', value: 'Sektionsleiter'},
                {text: 'Nachwuchsleiter', value: 'Nachwuchsleiter'},
                {text: 'Akademieleiter', value: 'Akademieleiter'},
                {text: 'Trainer Kampfmannschaft', value: 'Trainer_Kampfmannschaft'},
                {text: 'Co-Trainer Kampfmannschaft', value: 'CoTrainer_Kampfmannschaft'},
                {text: 'Trainer Amateure',  value: 'Trainer_Amateure'},
                {text: 'Co-Trainer Amateure', value: 'CoTrainer_Amateure'},
                {text: 'Trainer U18', value: 'Trainer_U18'},
                {text: 'Co-Trainer U18', value: 'CoTrainer_U18'},
                {text: 'Trainer U16', value: 'Trainer_U16'},
                {text: 'Co-Trainer U16', value: 'CoTrainer_U16'},
                {text: 'Trainer U15', value: 'Trainer_U15'},
                {text: 'Co-Trainer U15', value: 'CoTrainer_U15'},
                {text: 'Trainer U14', value: 'Trainer_U14'},
                {text: 'Co-Trainer U14', value: 'CoTrainer_U14'},
                {text: 'Masseur', value: 'Masseur'},
                {text: 'Sportwissenschaftler', value: 'Sportwissenschaftler'},
                {text: 'Sportpsychologe', value: 'Sportpsychologe'},
                {text: 'Athletiktrainer', value: 'Athletiktrainer'},
                {text: 'Individualtrainer', value: 'Individualtrainer'},
                {text: 'Tormanntrainer', value: 'Tormanntrainer'},
                {text: 'Teamarzt', value: 'Teamarzt'},
                {text: 'Videoanalyst', value: 'Videoanalyst'},
                {text: 'Andere...', value: 'Andere...'},
            ],
            titleList: [
                {text: '', value: ''},
                {text: 'Mag.', value: 'Mag.'},
                {text: 'Dr.', value: 'Dr.'},
                {text: 'DI', value: 'DI'},
                {text: 'BA', value: 'Bak.'},
                {text: 'DDr.', value: 'DDr.'},
                {text: 'MMag.', value: 'MMag'},
            ],
            relativeTypeList: [
                {text: 'Vater', value: 'Vater'},
                {text: 'Mutter', value: 'Mutter'},
                {text: 'Sohn', value: 'Sohn'},
                {text: 'Tochter', value: 'Tochter'},
                {text: 'Ehepartner', value: 'Ehepartner'},
                {text: 'Lebensgefährte/in', value: 'Lebensgefährte/in'},
                {text: 'Bruder', value: 'Bruder'},
                {text: 'Schwester', value: 'Schwester'},
                {text: 'Grossvater', value: 'Grossvater'},
                {text: 'Grossmutter', value: 'Grossmutter'},
                {text: 'Stiefvater', value: 'Stiefvater'},
                {text: 'Stiefmutter', value: 'Stiefmutter'},
                {text: 'Stiefbruder', value: 'Stiefbruder'},
                {text: 'Stiefschwester', value: 'Stiefschwester'},
                {text: 'Tante', value: 'Tante'},
                {text: 'Onkel', value: 'Onkel'},
            ],
            relativeinput: {
                name: '',
                birthday: '',
                type: '',
                description: '',
            },
            person: {
                title       : '',
                lastname    : '',
                firstname   : '',
                birthday    : '',
                phonenumber : '',
                workphonenumber: '',
                mobilephonenumber: '',
                email       : '',
                homepage    : '',
                address     : '',
                country     : '',
                postalcode  : '',
                city        : '',
                description : '',
                positions   : '',
                club_company: '',
                hobbies: '',
                marital_status: '',
                create_account: false,
                relatives: []
            },
            club: {
                name : '',
                description : '',
                address : '',
                country : '',
                postalcode : '',
                city : '',
                email : '',
                homepage    : '',
                phonenumber : '',
                transfermarkt_link: '',
                positions: {
                    Präsident: '',
                    Vize_Präsident: '',
                    Geschäftsführer: '',
                    Obmann: '',
                    Sportlicher_Leiter: '',
                    Sportlicher_Leiter_Nachwuchs: '',
                    Sektionsleiter: '',
                    Akademieleiter: '',
                    Nachwuchsleiter: '',
                    Trainer_Kampfmannschaft: '',
                    CoTrainer_Kampfmannschaft: '',
                    Trainer_Amateure: '',
                    CoTrainer_Amateure: '',
                    Trainer_U18: '',
                    CoTrainer_U18: '',
                    Trainer_U16: '',
                    CoTrainer_U16: '',
                    Trainer_U15: '',
                    CoTrainer_U15: '',
                    Trainer_U14: '',
                    CoTrainer_U14: '',
                    Masseur: '',
                    Sportwissenschaftler: '',
                    Sportpsychologe: '',
                    Athletiktrainer: '',
                    Individualtrainer: '',
                    Tormanntrainer: '',
                    Teamarzt: '',
                    Videoanalyst: '',
                }
            },
            company: {
                name : '',
                description : '',
                address : '',
                country : '',
                postalcode : '',
                city : '',
                email : '',
                homepage    : '',
                phonenumber : '',
                positions: {
                    Geschäftsführer: '',
                    Inhaber: '',
                    Eigentümer: '',
                    Abteilungsleiter: '',
                    Gebietsleiter: '',
                    Verkäufer: '',
                    Sekretär: '',
                    Buchhalter: ''
                }
            },
            partnerlist: {

            },
            formErrors: {
                message: '',
                errors: {}
            },
            createSuccess: false,
            loading: false,
            flash: {
                message: '',
                type: ''
            }
        }
    },
    components: {
      ModelSelect
    },
    mounted() {
        (!this.default) ? this.selectedType = 'person' : this.selectedType = this.default;

        axios.get('/partnerlist?noPaginate=true').then(res => {
            let list = [];

            res.data.map(item => {
                if (item.partnertype !== 'person') {
                    return list.push({ text: item.name , value: item.partnertype + ',' +    item.id});
                }
            })
            this.partnerlist = list;
        });
    },
    methods: {
        addRelative() {
            let relative = {};
            relative.relateable_type = 'App\Person';
            relative.relateable_id = null;
            relative.type = this.relativeinput.type;
            relative.name = this.relativeinput.name;
            relative.birthday = this.relativeinput.birthday;
            relative.description = this.relativeinput.description;


            this.person.relatives.push(relative);

            this.relativeinput = {
                name: '',
                birthday: '',
                type: '',
                description: '',
            }
        },
        onPositionSelect() {
            if(this.person.positions === 'Andere...') {
                this.showPositionFreeText = true
                this.person.positions = '';
            }
        },
        selectType() {
            console.log(this.selectedType);
        },
        clearForm() {

            this.formShown = false;

            this.company = {
                name : '',
                description : '',
                address : '',
                country : '',
                postalcode : '',
                city : '',
                email : '',
                homepage    : '',
                phonenumber : '',
            };

            this.person = {
                title       : '',
                lastname    : '',
                firstname   : '',
                birthday    : '',
                phonenumber : '',
                workphonenumber: '',
                mobilephonenumber: '',
                email       : '',
                homepage    : '',
                address     : '',
                country     : '',
                postalcode  : '',
                city        : '',
                description : '',
                positions   : '',
                club_company: '',
                hobbies: '',
                marital_status: '',
                create_account: false,
                relatives: []
            };

            this.club = {
                name : '',
                description : '',
                address : '',
                country : '',
                postalcode : '',
                city : '',
                email : '',
                homepage    : '',
                phonenumber : '',
                transfermarkt_link: '',
                positions: {
                    Präsident: '',
                    Vize_Präsident: '',
                    Geschäftsführer: '',
                    Obmann: '',
                    Sportlicher_Leiter: '',
                    Sportlicher_Leiter_Nachwuchs: '',
                    Sektionsleiter: '',
                    Akademieleiter: '',
                    Nachwuchsleiter: '',
                    Trainer_Kampfmannschaft: '',
                    CoTrainer_Kampfmannschaft: '',
                    Trainer_Amateure: '',
                    CoTrainer_Amateure: '',
                    Trainer_U18: '',
                    CoTrainer_U18: '',
                    Trainer_U16: '',
                    CoTrainer_U16: '',
                    Trainer_U15: '',
                    CoTrainer_U15: '',
                    Trainer_U14: '',
                    CoTrainer_U14: '',
                    Masseur: '',
                    Sportwissenschaftler: '',
                    Sportpsychologe: '',
                    Athletiktrainer: '',
                    Individualtrainer: '',
                    Tormanntrainer: '',
                    Teamarzt: '',
                    Videoanalyst: '',
                }
            };
        },
        sendForm() {
            this.formErrors.message = '';
            this.formErrors.errors = {};
            this.loading = true;
            let modeldata = void 0;
            let data = new FormData();

            if (this.selectedType === 'club') {
                modeldata = this.club;
                data.append('modeltype', 'club');
                data.append('name', this.club.name);
                (this.club.description !== '') ? data.append('description', this.club.description) : null;
                (this.club.country !== '') ? data.append('country', this.club.country) : null;
                (this.club.address !== '') ? data.append('address', this.club.address) : null;
                (this.club.postalcode !== '') ? data.append('postalcode', this.club.postalcode) : null;
                (this.club.city !== '') ? data.append('city', this.club.city) : null;
                (this.club.email !== '') ? data.append('email', this.club.email) : null;
                (this.club.phonenumber !== '') ? data.append('phonenumber', this.club.phonenumber) : null;
                (this.club.homepage !== '') ? data.append('homepage', this.club.homepage) : null;
                (this.club.transfermarkt_link !== '') ? data.append('transfermarkt_link', this.club.transfermarkt_link) : null;
                data.append('positions', JSON.stringify(this.club.positions));
            }
            if (this.selectedType === 'person') {
                modeldata = this.person;
                data.append('modeltype', 'person');
                (this.person.title !== '') ? (data.append('title', this.person.title)) : null;
                (this.person.hobbies !== '') ? (data.append('hobbies', this.person.hobbies)) : null;
                (this.person.firstname !== '') ? (data.append('firstname', this.person.firstname)) : null;
                (this.person.lastname !== '') ? (data.append('lastname', this.person.lastname)) : null;
                (this.person.positions !== '') ? (data.append('positions', this.person.positions)) : null;
                (this.person.description !== '') ? (data.append('description', this.person.description)) : null;
                (this.person.marital_status !== '') ? (data.append('marital_status', this.person.marital_status)) : null;

                (this.person.address !== '') ? (data.append('address', this.person.address)) : null;
                (this.person.country !== '') ? (data.append('country', this.person.country)) : null;
                (this.person.postalcode !== '') ? (data.append('postalcode', this.person.postalcode)) : null;
                (this.person.city !== '') ? (data.append('city', this.person.city)) : null;

                (this.person.email !== '') ? (data.append('email', this.person.email)) : null;
                (this.person.homepage !== '') ? data.append('homepage', this.person.homepage) : null;
                (this.person.phonenumber !== '') ? (data.append('phonenumber', this.person.phonenumber)) : null;
                (this.person.workphonenumber !== '') ? (data.append('work_phonenumber', this.person.workphonenumber)) : null;
                (this.person.mobilephonenumber !== '') ? (data.append('mobile_phonenumber', this.person.mobilephonenumber)) : null;

                (this.person.birthday !== '') ? (data.append('birthday', this.person.birthday)) : null;

                if (this.person.club_company !== '') {
                    console.log(this.person.club_company);
                    data.append('club_company', `${this.person.club_company}`)
                }
                if (this.person.relatives.length > 0) {
                    data.append('relatives', JSON.stringify(this.person.relatives));
                }
                if (this.person.create_account === true) {
                    data.append('create_account', 'true')
                }
            }
            if (this.selectedType === 'company') {
                modeldata = this.company;
                data.append('modeltype', 'company');
                data.append('name', this.company.name);
                (this.company.description !== '') ? data.append('description', this.company.description) : null;
                (this.company.country !== '') ? data.append('country', this.company.country) : null;
                (this.company.address !== '') ? data.append('address', this.company.address) : null;
                (this.company.postalcode !== '') ? data.append('postalcode', this.company.postalcode) : null;
                (this.company.city !== '') ? data.append('city', this.company.city) : null;
                (this.company.email !== '') ? data.append('email', this.company.email) : null;
                (this.company.homepage !== '') ? data.append('homepage', this.company.homepage) : null;
                (this.company.phonenumber !== '') ? data.append('phonenumber', this.company.phonenumber) : null;
                data.append('positions', JSON.stringify(this.company.positions));
            }



            axios.post(`/partners`, data).then(res => {
                this.loading = false;
                this.createSuccess = true;
                this.flash.message = 'Partner erfolgreich erstellt';
                this.flash.type = 'is-success';
                this.clearForm();

                setTimeout(() => {
                    this.createSuccess = false;
                }, 5000)
            }).catch(e => {
                this.formErrors.errors = e.response.data.errors
                this.formErrors.message = 'Es sind Fehler aufgetreten.'
                this.loading = false;
                return
            });
        }
    }
}
</script>

<style scoped>
    * {
        border-radius: 0px !important;
    }
    * input:not([type="checkbox"]) {
        padding: 0.67861429em 1em 0.67861429em 1em !important;
        height: 43px !important;
    }
    .ck-new-partner {
        outline: 1px solid #ddd;
        padding: 1rem;
        margin-bottom: 2rem;
    }

    .action-button {
        border-radius: 0;
        width: 66%;
    }

    .action-button.is-narrow {
        width: auto;
    }

    .hovertitle {
        display: none;
    }

    .input-padded {
        padding: 0.67861429em 1em 0.67861429em 1em;
        height: 43px;
    }

    .ck-search {
        width: 100%;
    }

    .ck-search * {
        border-radius: 0px !important;
    }

    /* override for select */
    .select:not(.is-multiple)::after {
        margin-top: 0;
    }

    .bounce-enter-active {
        animation: bounce-in .2s;
    }
    .bounce-leave-active {
        animation: bounce-in .2s reverse;
    }

    @keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ckCreatePartner.vue